export default "/images/ae9529b01678545256af498da85c2b2f.jpg";